import { LuIcon, Menu, type MenuGroupProps, Text } from "@overmap-ai/blocks"
import { type Field, fieldDataMapping, UNLABELLED_FIELD_LABEL } from "@overmap-ai/forms"

import { genericMemo } from "../../utils/optimization"

export interface FieldGroupProps<TField extends Field> extends MenuGroupProps {
	/** this prop can be used if a subset of projects need to be selected from, if not specified, all projects will
	 * be allowed to be selected from. */
	fields: TField[]
	onFieldSelect: (field: TField) => void
}

export const FieldGroup = genericMemo(<TField extends Field>(props: FieldGroupProps<TField>) => {
	const { ref, fields, onFieldSelect, ...rest } = props

	return (
		<Menu.Group ref={ref} {...rest}>
			{fields.map((field) => (
				<Menu.Item key={field.id} onSelect={() => onFieldSelect(field)} className="truncate">
					<LuIcon icon={fieldDataMapping[field.type].icon} />
					<Text className="truncate">{field.label || UNLABELLED_FIELD_LABEL}</Text>
				</Menu.Item>
			))}
		</Menu.Group>
	)
})
